import { Controllers } from 'lib/enums/routes/_controllers';
import { AuthRoutes } from 'lib/enums/routes/auth';
import { UserWhole } from 'lib/interfaces/database/user';
import { BaseService } from 'services/_base';

export class AuthService extends BaseService {
  private static instance: AuthService;

  static getInstance(): AuthService {
    if (!AuthService.instance) {
      AuthService.instance = new AuthService();
    }

    return AuthService.instance;
  }

  private constructor() {
    super({
      controller: Controllers.auth,
    });
  }

  login(email: string, password: string) {
    return this.POST(
      {
        uri: AuthRoutes.Login,
      },
      { email, password }
    )
      .then((result: { token: string; user: UserWhole }) => result)
      .catch((error) => {
        console.error(error);
        return undefined;
      });
  }

  refreshToken(silently: boolean) {
    return this.GET({
      uri: AuthRoutes.RefreshToken,
    })
      .then((result: { token: string; user: UserWhole }) => result)
      .catch((error) => {
        if (!silently) {
          console.error(error);
        }
        return undefined;
      });
  }

  logout() {
    return this.GET({
      uri: AuthRoutes.Logout,
    })
      .then(() => {
        console.debug('Logout successful');
        return true;
      })
      .catch((error) => {
        console.debug('Logout failed');
        console.error(error);
        return false;
      });
  }
}
